import {
  getApiV1ThreeLetterCodePartnerAdminsUsersUserId,
  getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdKey,
} from '@fukuri-admins/apis/client/gen/endpoints';
import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200 } from '@fukuri-admins/apis/client/gen/model';
import { useFetch } from '@fukuri-admins/hooks/common';

type Args = {
  /** 3文字コード */
  threeLetterCode: string;
  /** 利用者ID */
  userId: number;
};

type ReturnType = {
  /** 利用者データ */
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserId200;
};

/**
 * useGetPartnerAdminsUserフックの型定義
 */
type IUseGetPartnerAdminsUser = (args: Args) => ReturnType;

/**
 * パートナー管理者向け利用者詳細取得フック
 */
export const useGetPartnerAdminsUser: IUseGetPartnerAdminsUser = ({ threeLetterCode, userId }) => {
  const { data } = useFetch(
    getGetApiV1ThreeLetterCodePartnerAdminsUsersUserIdKey(threeLetterCode, String(userId)),
    () => getApiV1ThreeLetterCodePartnerAdminsUsersUserId(threeLetterCode, String(userId)),
    { suspense: true }
  );

  return {
    data,
  };
};
